import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-edit-subscription-benefits",
  templateUrl: "./edit-subscription-benefits.component.html",
  styleUrls: ["./edit-subscription-benefits.component.scss"],
})
export class EditSubscriptionBenefitsComponent {
  benefits = [
    { key: "editsubscriptionMassage", label: "Massage", value: 0 },
    { key: "editsubscriptionInbody", label: "Inbody", value: 0 },
    { key: "editsubscriptionMeditation", label: "Meditation", value: 0 },
    { key: "editsubscriptionCupping", label: "Cupping", value: 0 },
    { key: "editsubscriptionInvitation", label: "Invitation", value: 0 },
    { key: "editsubscriptionPTSession", label: "PTSessions", value: 0 },
    { key: "editsubscriptionFitness", label: "Fitness", value: 0 },
    { key: "editsubscriptionNutration", label: "Nutration", value: 0 },
    { key: "editsubscriptionFreeDays", label: "FreeDays", value: 0 },
    { key: "editsubscriptionTraining", label: "Training", value: 0 },
    { key: "editsubscriptionCashback", label: "Cash Back", value: 0 },
    { key: "editsubscriptionFreeze", label: "Freezes", value: 0 },
    { key: "editsubscriptionKidsArea", label: "KidsArea", value: 0 },
  ];

  constructor(
    private dialogRef: MatDialogRef<EditSubscriptionBenefitsComponent>,
  ) {}

  submit(): void {
    this.dialogRef.close(this.benefits);
  }

  close(): void {
    this.dialogRef.close();
  }
}
